export default {
  sales: [],
  contact: {},
  loading: false
}
